import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApiModule } from './services/api/api.module';
import { environment } from 'src/environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CoreProvider } from './services/core.provider';
import { apiAuthInterceptor } from './services/auth/auth.interceptor';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    BrowserModule,
    IonicModule.forRoot({mode: 'md'}),
    ApiModule.forRoot({ rootUrl: environment.apiBaseUrl }),
    AppRoutingModule
  ],
  providers: [
    CoreProvider,
    provideHttpClient(
      withInterceptors([apiAuthInterceptor])
    ),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
